// LuckyBet Toggle Button

luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  gameData.goldenBetBtn = button;

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  button.canPlaceBet = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    // Dont show in freespins
    return !freespins.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes =
      this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake =
      resourceManager.getController("stakeController").BaseStake / 20;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    var buttonToDim = button._flags.showLuckyBetActive
      ? this.button.buttonEnabled
      : this.button.buttonDisabled;

    buttonToDim.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      button.onConfig.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionStarted",
      button.promotionStarted.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionEnded",
      button.promotionEnded.bind(button)
    );
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage"
    );
    button.animParent = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );

    // create here on top of button
    button.luckyBetAnim = resourceManager.createObject(
      "movie",
      "luckyBetAnim",
      button.animParent,
      { definition: "goldenBetOn", x: -125, y: -110, loop: false, scale: 1 }
    );
    button.luckyBetAnim.gotoAndStop(0);
    button.luckyBetAnim.visible = false;
    button.luckyBetMessage.alpha = 0.0;
    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;

    // create shine animation
    button.luckyBetShine = resourceManager.createObject(
      "movie",
      "luckyBetShine",
      button.animParent,
      { definition: "goldenBetShine", x: -86, y: -60, loop: false, scale: 1 }
    );
    button.luckyBetShine.gotoAndStop(0);
    button.luckyBetShine.visible = false;
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    resourceManager.getContainer(
      "goldenBetBackgroundContainer"
    ).visible = false;
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetShineTimeline !== undefined) {
      button.luckyBetShineTimeline.kill();
    }
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.luckyBetAnim.gotoAndStop(0);

      gameData.encoreEnabled = false;

      button.handleStakeChange();
    }
  };

  button.handleStakeChange = function () {
    let bpl = resourceManager.getController("stakeController").BaseStake / 25;
    let luckyBetEnabled = gameData.encoreEnabled;
    resourceManager
      .getController("stakeController")
      .setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(
      resourceManager.getController("stakeController").BaseStake *
        (luckyBetEnabled ? 1.5 : 1),
      bpl
    );
    resourceManager.getController("stakeController").broadcastCurrentStake();

    // Set the "STAKE CHANGED TO" text on the lucky bet panel
    const panelStakeText = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:currentStakeText"
    );
    panelStakeText.setTranslationPhrase("t_stakeChangedTo");
    panelStakeText.text += " ";
    panelStakeText.text += gdk.formatCurrency(
      resourceManager.getController("stakeController").CurrentStake
    );
    panelStakeText.setText(panelStakeText.text);
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    button.handleStakeChange();
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.hideMessage = function () {
    if (button.outerFadeTimer !== undefined)
      button.luckyBetMessage.visible = false;
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;

    game.resetWinnings();

    if (button._flags.showLuckyBetActive) {
      resourceManager.getContainer(
        "goldenBetBackgroundContainer"
      ).visible = true;
      if (button.luckyBetMessage !== undefined) {
        button.luckyBetMessage.visible = true;
        button.luckyBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(
          2500,
          undefined,
          function () {
            button.innerFadeTimer = timerManager.addTimer(
              250,
              function (progress) {
                button.luckyBetMessage.alpha = 1 - progress;
              },
              function () {
                button.luckyBetMessage.alpha = 0.0;
              }
            );
          }
        );

        button.luckyBetShineTimeline = gsap.timeline({ repeat: -1 }).call(
          () => {
            if (button.canEnable()) {
              button.luckyBetShine.visible = true;
              button.luckyBetShine.gotoAndPlay(0);
              timerManager.addTimer(500, undefined, function () {
                button.luckyBetShine.visible = false;
                button.luckyBetShine.gotoAndStop(0);
              });
            }
          },
          undefined,
          "<+=8"
        );
        button.luckyBetShineTimeline.play();

        button.luckyBetAnim.gotoAndPlay(0);
        button.luckyBetAnim.visible = true;
        timerManager.addTimer(500, undefined, function () {
          button.luckyBetAnim.visible = false;
        });
        soundManager.play("activateGoldenBet");

        gameData.encoreEnabled = true;
        button.handleStakeChange();
      }
    } else {
      resourceManager.getContainer(
        "goldenBetBackgroundContainer"
      ).visible = false;
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play("cancelGoldenBet");
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "luckyBetToggleButton",
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
